/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/stocks'
export default icon
